/* istanbul ignore file */
import { find, get } from 'underscore';
import { ceil } from 'lodash';

// ref: /private/Campaign/MT/Source/Interface/Entity/CurrencyType.cs

export const CurrencyCode2CurrencyId = {
  AUD: 1,
  BRL: 2,
  ARS: 15,
  CAD: 3,
  CLP: 16,
  COP: 18,
  DKK: 5,
  EUR: 6,
  HKD: 30,
  INR: 36,
  JPY: 8,
  MXN: 57,
  NOK: 9,
  NZD: 10,
  PEN: 64,
  SGD: 74,
  ZAR: 13,
  SEK: 11,
  CHF: 4,
  USD: 12,
  GBP: 7,
  VEF: 87,
  TWD: 82,
  MYR: 58,
  PHP: 65,
  VND: 88,
  THB: 78,
  IDR: 34,
  DZD: 23,
  BHD: 42,
  EGP: 25,
  IQD: 37,
  JOD: 41,
  KWD: 46,
  LBP: 48,
  MAD: 52,
  QAR: 69,
  OMR: 62,
  SAR: 72,
  TND: 79,
  CNY: 17,
  TRY: 93,
  PLN: 67,
  AED: 21,
  ILS: 35,
  NGN: 99,
  KRW: 45,
};

export const MTCurrencyConvertor = {
  AustralianDollar: 'AUD',
  BrazilianReal: 'BRL',
  CanadianDollar: 'CAD',
  SwissFranc: 'CHF',
  DanishKrone: 'DKK',
  EURO: 'EUR',
  UKPound: 'GBP',
  JapaneseYen: 'JPY',
  NorwegianKrone: 'NOK',
  NewZealandDollar: 'NZD',
  SwedishKrona: 'SEK',
  USDollar: 'USD',
  SouthAfricanRand: 'ZAR',
  ArgentinePeso: 'ARS',
  ChileanPeso: 'CLP',
  YuanRenminbi: 'CNY',
  ColombianPeso: 'COP',
  UAEDirham: 'AED',
  AlgerianDinar: 'DZD',
  EgyptianPound: 'EGP',
  HongKongDollar: 'HKD',
  IndonesianRupiah: 'IDR',
  IsraeliSheqel: 'ILS',
  IndianRupee: 'INR',
  LebanesePound: 'LBP',
  MoroccanDirham: 'MAD',
  MexicanPeso: 'MXN',
  MalaysianRinggit: 'MYR',
  PeruvianNuevoSol: 'PEN',
  PhilippinePeso: 'PHP',
  Zloty: 'PLN',
  QatariRial: 'QAR',
  SaudiRiyal: 'SAR',
  SingaporeDollar: 'SGD',
  ThaiBaht: 'THB',
  NewTaiwanDollar: 'TWD',
  VenezuelanBolivar: 'VEF',
  VietnamDong: 'VND',
  NewTurkishLira: 'TRY',
  NigerianNaira: 'NGN',
  Won: 'KRW',
};

export const getConvertedCurrencyDealMinimumBid = (minimumBid, dealCurrency, accountCurrency, exchangeRateMapping) => {
  if (minimumBid && accountCurrency && exchangeRateMapping) {
    const dealCurrencyId = CurrencyCode2CurrencyId[MTCurrencyConvertor[dealCurrency] || 'USD'] || 12;
    const dealCurrencyToUSD = get(find(exchangeRateMapping, item => item.CurrencyId === dealCurrencyId), 'ExchangeRateValue', 1);

    const accountCurrencyId = CurrencyCode2CurrencyId[accountCurrency] || 12;
    const accountCurrencyToUSD = get(find(exchangeRateMapping, item => item.CurrencyId === accountCurrencyId), 'ExchangeRateValue', 1);

    return ceil((minimumBid * dealCurrencyToUSD) / accountCurrencyToUSD, 2);
  }
  return minimumBid;
};
